import Input from './component';
import { InputProps } from './types';

export default Input;
export type { InputProps };
